export default {
    '-1': 'Refusée',
    '-2': 'Annulée',
    '-3': 'Expirée',
    0: 'En attente',
    1: 'Validée',
}
